module.exports = __webpack_public_path__ + "static/img/page1-icon3.e427151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page1-icon3.png
// module id = 6CiL
// module chunks = 216